export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-6a82aae211e378cbbd7dcb6db239bc90.png";